
export const TASK_LIST_PAGENATIONS = 'TASK_LIST_PAGENATIONS';
export const TASK_LIST_DATA = 'TASK_LIST_DATA';
export const TASK_LIST_PERIOD = 'TASK_LIST_PERIOD';
export const TASK_STATUS = 'TASK_STATUS';
export const SET_TASK_STATUS_QUERY_TEXT = 'SET_TASK_STATUS_QUERY_TEXT';
export const SET_TASK_ORDER_BY_QUERY_TEXT = 'SET_TASK_ORDER_BY_QUERY_TEXT';
export const SET_TEAM_MEMBERS = 'TASK_SET_TEAM_MEMBERS';
export const TASK_SET_ACTIVE_MEMBER = 'TASK_SET_ACTIVE_MEMBER';




// WEBPACK FOOTER //
// ./src/views/Task/flow/actionType.js